// This file is auto-generated by scripts/generate-form-schema.ts
// DO NOT EDIT MANUALLY - run 'pnpm generate-schema' to regenerate

export type StaticFieldSchema = {
  key: string
  type: 'string' | 'number' | 'boolean' | 'object' | 'array' | 'enum'
  required: boolean
  component:
    | 'TextInput'
    | 'Select'
    | 'Checkbox'
    | 'Textarea'
    | 'NumberInput'
    | 'ArrayEditor'
  numberFormat?: 'integer' | 'float' | 'currency'
  options?:
    | Array<string>
    | Array<{ label: string; value: string; sublabel?: string }>
  nested?: Array<StaticFieldSchema>
  fullPath?: string
  description?: string
  /** The spec marks this field readOnly, so no request body may carry it. */
  readOnly?: boolean
}

export const lineOfCreditLoanTypeSchema: Array<StaticFieldSchema> = [
  {
    key: 'id',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'id',
    readOnly: true,
  },
  {
    key: 'createdAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'createdAt',
    readOnly: true,
  },
  {
    key: 'updatedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'updatedAt',
    readOnly: true,
  },
  {
    key: 'deletedAt',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'deletedAt',
    readOnly: true,
  },
  {
    key: 'type',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'type',
    options: ['lineOfCredit'],
  },
  {
    key: 'lineOfCreditType',
    type: 'enum',
    required: true,
    component: 'Select',
    fullPath: 'lineOfCreditType',
    options: ['revolving', 'nonRevolving'],
  },
  {
    key: 'assetType',
    type: 'enum',
    required: true,
    component: 'Select',
    fullPath: 'assetType',
    options: [
      'personalClosedEndUnsecured',
      'personalOpenEndUnsecured',
      'personalClosedEndSecured',
      'personalOpenEndSecured',
      'motorMVRISC',
      'motorDirect',
      'motorLease',
      'businessClosedEndUnsecured',
      'businessOpenEndUnsecured',
      'businessClosedEndSecured',
      'businessOpenEndSecured',
    ],
  },
  {
    key: 'externalId',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'externalId',
  },
  {
    key: 'name',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'name',
  },
  {
    key: 'assetDisplayName',
    type: 'string',
    required: true,
    component: 'TextInput',
    fullPath: 'assetDisplayName',
  },
  {
    key: 'txDescriptorAssetDisplayName',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'txDescriptorAssetDisplayName',
  },
  {
    key: 'description',
    type: 'string',
    required: false,
    component: 'Textarea',
    fullPath: 'description',
  },
  {
    key: 'status',
    type: 'enum',
    required: false,
    component: 'Select',
    fullPath: 'status',
    options: ['inactive', 'active'],
  },
  {
    key: 'currency',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'currency',
  },
  {
    key: 'timezone',
    type: 'string',
    required: false,
    component: 'TextInput',
    fullPath: 'timezone',
  },
  {
    key: 'paymentAllowedWhenChargedOff',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'paymentAllowedWhenChargedOff',
  },
  {
    key: 'paydayNotices',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'paydayNotices',
    nested: [
      {
        key: 'sendFirstPaymentWithdrawalNotice',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paydayNotices.sendFirstPaymentWithdrawalNotice',
      },
      {
        key: 'sendConsumerRightsNotice',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paydayNotices.sendConsumerRightsNotice',
      },
    ],
  },
  {
    key: 'futurePay',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'futurePay',
    nested: [
      {
        key: 'achDebitTiming',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'futurePay.achDebitTiming',
        options: ['initiateOnDueDate', 'hitOnDueDate'],
      },
      {
        key: 'achDebitTimingShiftOnNonBusinessDay',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'futurePay.achDebitTimingShiftOnNonBusinessDay',
        options: ['forward', 'backward'],
      },
      {
        key: 'overpaymentAmountLimitFactor',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'futurePay.overpaymentAmountLimitFactor',
        numberFormat: 'currency',
      },
      {
        key: 'balanceCheck',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'futurePay.balanceCheck',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'futurePay.balanceCheck.enabled',
          },
          {
            key: 'checkOffsetDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'futurePay.balanceCheck.checkOffsetDays',
            numberFormat: 'integer',
          },
          {
            key: 'thresholds',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'futurePay.balanceCheck.thresholds',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'futurePay.balanceCheck.thresholds[0]',
                nested: [
                  {
                    key: 'zone',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'futurePay.balanceCheck.thresholds[0].zone',
                    options: ['balanceRed', 'balanceYellow'],
                  },
                  {
                    key: 'value',
                    type: 'number',
                    required: false,
                    component: 'NumberInput',
                    fullPath: 'futurePay.balanceCheck.thresholds[0].value',
                    numberFormat: 'integer',
                  },
                ],
              },
            ],
          },
          {
            key: 'debitLogic',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'futurePay.balanceCheck.debitLogic',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'futurePay.balanceCheck.debitLogic[0]',
                nested: [
                  {
                    key: 'condition',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'futurePay.balanceCheck.debitLogic[0].condition',
                    options: [
                      'balanceRed',
                      'balanceYellow',
                      'balanceNA',
                      'balanceBroken',
                      'balanceGreen',
                    ],
                  },
                  {
                    key: 'action',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'futurePay.balanceCheck.debitLogic[0].action',
                    options: ['cancel', 'debit', 'reschedule'],
                  },
                ],
              },
            ],
          },
          {
            key: 'rescheduleBufferInDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'futurePay.balanceCheck.rescheduleBufferInDays',
            numberFormat: 'integer',
          },
          {
            key: 'rescheduleBufferDayType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'futurePay.balanceCheck.rescheduleBufferDayType',
            options: ['calendar', 'business'],
          },
        ],
      },
    ],
  },
  {
    key: 'paymentHoldDays',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'paymentHoldDays',
    nested: [
      {
        key: 'holdDayType',
        type: 'enum',
        required: true,
        component: 'Select',
        fullPath: 'paymentHoldDays.holdDayType',
        options: ['calendar', 'business'],
      },
      {
        key: 'numHoldDays',
        type: 'number',
        required: true,
        component: 'NumberInput',
        fullPath: 'paymentHoldDays.numHoldDays',
        numberFormat: 'integer',
      },
    ],
  },
  {
    key: 'openToBuyCalculation',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'openToBuyCalculation',
    nested: [
      {
        key: 'calculationType',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'openToBuyCalculation.calculationType',
        options: [
          'transactionStatus',
          'transactionHoldDays',
          'transactionStatusAndHoldDays',
        ],
      },
    ],
  },
  {
    key: 'fees',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'fees',
    nested: [
      {
        key: 'originationFeeChargeLogic',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'fees.originationFeeChargeLogic',
        options: [
          '',
          'onTopPeriodicPayment',
          'blendWithPeriodicPayment',
          'chargedAtOrigination',
        ],
      },
      {
        key: 'originationFeeAPRCalcOverride',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'fees.originationFeeAPRCalcOverride',
        options: ['noOverride', 'atOrigination'],
      },
      {
        key: 'originationFeeDisplayName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'fees.originationFeeDisplayName',
      },
      {
        key: 'drawFeeChargeLogic',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'fees.drawFeeChargeLogic',
        options: [
          '',
          'onTopPeriodicPayment',
          'blendWithPeriodicPayment',
          'chargedAtOrigination',
        ],
      },
      {
        key: 'drawFeeDisplayName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'fees.drawFeeDisplayName',
      },
    ],
  },
  {
    key: 'refunds',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'refunds',
    nested: [
      {
        key: 'isRefundAllowed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'refunds.isRefundAllowed',
      },
    ],
  },
  {
    key: 'paymentWaterfall',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'paymentWaterfall',
    nested: [
      {
        key: 'single',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'paymentWaterfall.single',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'paymentWaterfall.single[0]',
            nested: [
              {
                key: 'transactionType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'paymentWaterfall.single[0].transactionType',
                options: ['payment', 'serviceCredit'],
              },
              {
                key: 'loanStatus',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'paymentWaterfall.single[0].loanStatus',
                options: ['active', 'accelerated', 'chargedOff'],
              },
              {
                key: 'balancesOrder',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'paymentWaterfall.single[0].balancesOrder',
                nested: [
                  {
                    key: '0',
                    type: 'enum',
                    required: true,
                    component: 'Select',
                    fullPath: 'paymentWaterfall.single[0].balancesOrder[0]',
                    options: [
                      'overdueFee',
                      'overdueAccruedInterest',
                      'overduePrincipal',
                      'dueFee',
                      'dueAccruedInterest',
                      'duePrincipal',
                      'nonDueFee',
                      'nonDueAccruedInterest',
                      'nonDuePrincipal',
                      'chargedOffPrincipal',
                      'chargedOffAccruedInterest',
                      'chargedOffFee',
                      'nonAccrualFee',
                      'nonAccrualInterest',
                      'nonAccrualPrincipal',
                    ],
                  },
                ],
              },
              {
                key: 'feesOrder',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'paymentWaterfall.single[0].feesOrder',
                nested: [
                  {
                    key: '0',
                    type: 'enum',
                    required: true,
                    component: 'Select',
                    fullPath: 'paymentWaterfall.single[0].feesOrder[0]',
                    options: [
                      'originationFee',
                      'drawFee',
                      'modificationFee',
                      'lateFee',
                      'membershipFee',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'multi',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'paymentWaterfall.multi',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'paymentWaterfall.multi[0]',
            nested: [
              {
                key: 'transactionType',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'paymentWaterfall.multi[0].transactionType',
                options: ['payment', 'serviceCredit'],
              },
              {
                key: 'loansOrder',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'paymentWaterfall.multi[0].loansOrder',
                nested: [
                  {
                    key: '0',
                    type: 'enum',
                    required: true,
                    component: 'Select',
                    fullPath: 'paymentWaterfall.multi[0].loansOrder[0]',
                    options: [
                      'highestInterestRate',
                      'lowestInterestRate',
                      'oldestLoanDate',
                      'newestLoanDate',
                      'highestOutstandingBalance',
                      'lowestOutstandingBalance',
                      'activeFirst',
                      'chargedOffFirst',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'multiPrioritizeNonDueEqually',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentWaterfall.multiPrioritizeNonDueEqually',
      },
      {
        key: 'multiPrioritizePromoRegZ',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentWaterfall.multiPrioritizePromoRegZ',
      },
      {
        key: 'multiPrioritizeOverdue',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'paymentWaterfall.multiPrioritizeOverdue',
      },
    ],
  },
  {
    key: 'managedByPeach',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'managedByPeach',
  },
  {
    key: 'automatedDebtValidationNotification',
    type: 'array',
    required: false,
    component: 'ArrayEditor',
    fullPath: 'automatedDebtValidationNotification',
    nested: [
      {
        key: '0',
        type: 'array',
        required: true,
        component: 'ArrayEditor',
        fullPath: 'automatedDebtValidationNotification[0]',
        nested: [
          {
            key: '0',
            type: 'string',
            required: true,
            component: 'TextInput',
            fullPath: 'automatedDebtValidationNotification[0][0]',
          },
        ],
      },
    ],
  },
  {
    key: 'creditReporting',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'creditReporting',
    nested: [
      {
        key: 'isCreditReportingAllowed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'creditReporting.isCreditReportingAllowed',
      },
      {
        key: 'metro2',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'creditReporting.metro2',
        nested: [
          {
            key: 'innovisProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.innovisProgramIdentifier',
          },
          {
            key: 'equifaxProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.equifaxProgramIdentifier',
          },
          {
            key: 'experianProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.experianProgramIdentifier',
          },
          {
            key: 'transunionProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.transunionProgramIdentifier',
          },
          {
            key: 'reporterName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterName',
          },
          {
            key: 'reporterAddress',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterAddress',
          },
          {
            key: 'reporterTelephoneNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.reporterTelephoneNumber',
          },
          {
            key: 'softwareVendorName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.softwareVendorName',
          },
          {
            key: 'softwareVersionNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.softwareVersionNumber',
          },
          {
            key: 'microBiltPrbcProgramIdentifier',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.microBiltPrbcProgramIdentifier',
          },
          {
            key: 'innovisIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.innovisIdentificationNumber',
          },
          {
            key: 'equifaxIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.equifaxIdentificationNumber',
          },
          {
            key: 'experianIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.experianIdentificationNumber',
          },
          {
            key: 'transunionIdentificationNumber',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.transunionIdentificationNumber',
          },
          {
            key: 'portfolioType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.portfolioType',
            options: ['C', 'I', 'M', 'O', 'R'],
          },
          {
            key: 'accountType',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.accountType',
          },
          {
            key: 'interestTypeIndicator',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'creditReporting.metro2.interestTypeIndicator',
          },
          {
            key: 'creditorClassification',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.creditorClassification',
            options: [
              '01',
              '02',
              '03',
              '04',
              '05',
              '06',
              '07',
              '08',
              '09',
              '10',
              '11',
              '12',
              '13',
              '14',
              '15',
            ],
          },
          {
            key: 'skipSegments',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'creditReporting.metro2.skipSegments',
            nested: [
              {
                key: '0',
                type: 'enum',
                required: true,
                component: 'Select',
                fullPath: 'creditReporting.metro2.skipSegments[0]',
                options: [
                  'header',
                  'baseSegment',
                  'k1Segment',
                  'k2Segment',
                  'l1Segment',
                ],
              },
            ],
          },
          {
            key: 'roundingMethod',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'creditReporting.metro2.roundingMethod',
            options: ['roundDownWhole', 'roundUpWhole'],
          },
        ],
      },
    ],
  },
  {
    key: 'useExternalIdInUI',
    type: 'boolean',
    required: false,
    component: 'Checkbox',
    fullPath: 'useExternalIdInUI',
  },
  {
    key: 'snapshots',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'snapshots',
    nested: [
      {
        key: 'reportDaysWhenPaidOff',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'snapshots.reportDaysWhenPaidOff',
        numberFormat: 'integer',
      },
    ],
  },
  {
    key: 'extraFields',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'extraFields',
    nested: [],
  },
  {
    key: 'companyConfigOverride',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'companyConfigOverride',
    nested: [
      {
        key: 'legalName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.legalName',
      },
      {
        key: 'brandName',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.brandName',
      },
      {
        key: 'support',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.support',
        nested: [
          {
            key: 'phone',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.phone',
          },
          {
            key: 'email',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.email',
          },
          {
            key: 'departmentName',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.departmentName',
          },
          {
            key: 'mailingAddress',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.mailingAddress',
            nested: [
              {
                key: 'addressLine1',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.addressLine1',
              },
              {
                key: 'addressLine2',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.addressLine2',
              },
              {
                key: 'city',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.support.mailingAddress.city',
              },
              {
                key: 'countyOrRegion',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.countyOrRegion',
              },
              {
                key: 'state',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.support.mailingAddress.state',
              },
              {
                key: 'postalCode',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.postalCode',
              },
              {
                key: 'country',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.country',
              },
              {
                key: 'POBox',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.support.mailingAddress.POBox',
              },
              {
                key: 'timezone',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.support.mailingAddress.timezone',
              },
            ],
          },
          {
            key: 'outboundCallRecordingConsentScript',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath:
              'companyConfigOverride.support.outboundCallRecordingConsentScript',
          },
          {
            key: 'privacyPolicyUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.support.privacyPolicyUrl',
          },
          {
            key: 'phoneSupportPleaseHoldMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportPleaseHoldMessage',
          },
          {
            key: 'enableVoicemailWhenClosed',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'companyConfigOverride.support.enableVoicemailWhenClosed',
          },
          {
            key: 'phoneSupportClosedMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath: 'companyConfigOverride.support.phoneSupportClosedMessage',
          },
          {
            key: 'phoneSupportDisabledMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportDisabledMessage',
          },
          {
            key: 'phoneSupportClosedLeaveVoicemailMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportClosedLeaveVoicemailMessage',
          },
          {
            key: 'enableVoicemailWhenNoAgents',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'companyConfigOverride.support.enableVoicemailWhenNoAgents',
          },
          {
            key: 'phoneSupportNoAgentsLeaveVoicemailMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.phoneSupportNoAgentsLeaveVoicemailMessage',
          },
          {
            key: 'recordAllInboundVoiceCalls',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'companyConfigOverride.support.recordAllInboundVoiceCalls',
          },
          {
            key: 'recordAllOutboundVoiceCalls',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'companyConfigOverride.support.recordAllOutboundVoiceCalls',
          },
          {
            key: 'textSupportRejectUnknownNumberMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportRejectUnknownNumberMessage',
          },
          {
            key: 'textSupportPleaseWaitMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportPleaseWaitMessage',
          },
          {
            key: 'textSupportClosedPleaseWaitMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportClosedPleaseWaitMessage',
          },
          {
            key: 'textSupportFindNewAgentPleaseWaitMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportFindNewAgentPleaseWaitMessage',
          },
          {
            key: 'textSupportDisabledMessage',
            type: 'string',
            required: false,
            component: 'Textarea',
            fullPath:
              'companyConfigOverride.support.textSupportDisabledMessage',
          },
        ],
      },
      {
        key: 'openHours',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.openHours',
        nested: [
          {
            key: 'businessHours',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.openHours.businessHours',
            nested: [
              {
                key: 'normal',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.openHours.businessHours.normal',
              },
              {
                key: 'holidays',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath:
                  'companyConfigOverride.openHours.businessHours.holidays',
                nested: [
                  {
                    key: '0',
                    type: 'object',
                    required: true,
                    component: 'TextInput',
                    fullPath:
                      'companyConfigOverride.openHours.businessHours.holidays[0]',
                    nested: [
                      {
                        key: 'date',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.openHours.businessHours.holidays[0].date',
                      },
                      {
                        key: 'name',
                        type: 'string',
                        required: true,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.openHours.businessHours.holidays[0].name',
                      },
                      {
                        key: 'hours',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.openHours.businessHours.holidays[0].hours',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'brandAssets',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.brandAssets',
        nested: [
          {
            key: 'logos',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.brandAssets.logos',
            nested: [
              {
                key: 'primary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.logos.primary',
              },
              {
                key: 'small',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.logos.small',
              },
              {
                key: 'appLargeCentered',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.logos.appLargeCentered',
              },
              {
                key: 'appRegularNavigation',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.logos.appRegularNavigation',
              },
              {
                key: 'appCompactNavigation',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.logos.appCompactNavigation',
              },
            ],
          },
          {
            key: 'colors',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.brandAssets.colors',
            nested: [
              {
                key: 'primary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.primary',
              },
              {
                key: 'secondary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.secondary',
              },
              {
                key: 'tertiary',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.tertiary',
              },
              {
                key: 'lighten',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.lighten',
              },
              {
                key: 'button',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.button',
              },
              {
                key: 'link',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.colors.link',
              },
              {
                key: 'secondButton',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.colors.secondButton',
              },
              {
                key: 'secondButtonBackground',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.colors.secondButtonBackground',
              },
            ],
          },
          {
            key: 'copies',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.brandAssets.copies',
            nested: [
              {
                key: 'consent',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.brandAssets.copies.consent',
              },
              {
                key: 'disclosures',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.brandAssets.copies.disclosures',
              },
            ],
          },
        ],
      },
      {
        key: 'links',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.links',
        nested: [
          {
            key: 'helpUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.helpUrl',
          },
          {
            key: 'termsOfUseUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.termsOfUseUrl',
          },
          {
            key: 'privacyPolicyUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.privacyPolicyUrl',
          },
          {
            key: 'eSignDisclosureUrl',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.links.eSignDisclosureUrl',
          },
        ],
      },
      {
        key: 'showPoweredByPeach',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'companyConfigOverride.showPoweredByPeach',
      },
      {
        key: 'ui',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.ui',
        nested: [
          {
            key: 'directPaymentToDraw',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.directPaymentToDraw',
            options: ['', 'shown'],
          },
          {
            key: 'mobileFooter',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.mobileFooter',
            options: ['', 'hidden'],
          },
          {
            key: 'mobileHeader',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.mobileHeader',
            options: ['', 'hidden'],
          },
          {
            key: 'mobileDisclosures',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.mobileDisclosures',
            options: ['', 'hidden'],
          },
          {
            key: 'manageAutopayPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.manageAutopayPage',
            nested: [
              {
                key: 'minimumPaymentDue',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.manageAutopayPage.minimumPaymentDue',
                options: ['', 'hidden'],
              },
              {
                key: 'statementBalance',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.manageAutopayPage.statementBalance',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'makePaymentPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.makePaymentPage',
            nested: [
              {
                key: 'remainingBalance',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.makePaymentPage.remainingBalance',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'loginPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.loginPage',
            nested: [
              {
                key: 'fallbackAuthLink',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loginPage.fallbackAuthLink',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'managePaymentMethodsPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.managePaymentMethodsPage',
            nested: [
              {
                key: 'borrower',
                type: 'object',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.ui.managePaymentMethodsPage.borrower',
                nested: [
                  {
                    key: 'check',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.check',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'creditCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.creditCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'debitCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.debitCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'payroll',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.payroll',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'paymentNetwork',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.paymentNetwork',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'wire',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.wire',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'moneyOrder',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.moneyOrder',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'deleteButton',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.borrower.deleteButton',
                    options: ['', 'hidden'],
                  },
                ],
              },
              {
                key: 'agent',
                type: 'object',
                required: false,
                component: 'TextInput',
                fullPath:
                  'companyConfigOverride.ui.managePaymentMethodsPage.agent',
                nested: [
                  {
                    key: 'check',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.check',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'creditCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.creditCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'debitCard',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.debitCard',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'payroll',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.payroll',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'paymentNetwork',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.paymentNetwork',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'wire',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.wire',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'moneyOrder',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.moneyOrder',
                    options: ['', 'hidden'],
                  },
                  {
                    key: 'deleteButton',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath:
                      'companyConfigOverride.ui.managePaymentMethodsPage.agent.deleteButton',
                    options: ['', 'hidden'],
                  },
                ],
              },
            ],
          },
          {
            key: 'help',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.help',
            options: ['', 'hidden'],
          },
          {
            key: 'signOut',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.signOut',
            options: ['', 'hidden'],
          },
          {
            key: 'accountSettings',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.accountSettings',
            options: ['', 'hidden'],
          },
          {
            key: 'contactUs',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.contactUs',
            options: ['', 'hidden'],
          },
          {
            key: 'loanOptions',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.loanOptions',
            nested: [
              {
                key: 'managePaymentMethods',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.loanOptions.managePaymentMethods',
                options: ['', 'hidden'],
              },
              {
                key: 'makePayment',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.makePayment',
                options: ['', 'hidden'],
              },
              {
                key: 'changeDueDate',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.changeDueDate',
                options: ['', 'hidden'],
              },
              {
                key: 'getPayoffStatement',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.loanOptions.getPayoffStatement',
                options: ['', 'hidden'],
              },
              {
                key: 'changeNickname',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.changeNickname',
                options: ['', 'hidden'],
              },
              {
                key: 'manageAutopay',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.manageAutopay',
                options: ['', 'hidden'],
              },
              {
                key: 'drawFunds',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.loanOptions.drawFunds',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'accountSettingsPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.accountSettingsPage',
            nested: [
              {
                key: 'profile',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.profile',
                options: ['', 'hidden'],
              },
              {
                key: 'contactInformation',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.contactInformation',
                options: ['', 'hidden'],
              },
              {
                key: 'commPreferences',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.commPreferences',
                options: ['', 'hidden'],
              },
              {
                key: 'additionalContacts',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.additionalContacts',
                options: ['', 'hidden'],
              },
              {
                key: 'paymentMethods',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSettingsPage.paymentMethods',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'accountSummaryPage',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.accountSummaryPage',
            nested: [
              {
                key: 'summary',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.accountSummaryPage.summary',
                options: ['', 'hidden'],
              },
              {
                key: 'loanTerms',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.loanTerms',
                options: ['', 'hidden'],
              },
              {
                key: 'balancesDetails',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.balancesDetails',
                options: ['', 'hidden'],
              },
              {
                key: 'promotions',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.promotions',
                options: ['', 'hidden'],
              },
              {
                key: 'merchantDetails',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.merchantDetails',
                options: ['', 'hidden'],
              },
              {
                key: 'cardDetails',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath:
                  'companyConfigOverride.ui.accountSummaryPage.cardDetails',
                options: ['', 'hidden'],
              },
            ],
          },
          {
            key: 'caseTypeOrdering',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'companyConfigOverride.ui.caseTypeOrdering',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'companyConfigOverride.ui.caseTypeOrdering[0]',
                nested: [
                  {
                    key: 'category',
                    type: 'string',
                    required: false,
                    component: 'TextInput',
                    fullPath:
                      'companyConfigOverride.ui.caseTypeOrdering[0].category',
                  },
                  {
                    key: 'caseTypes',
                    type: 'array',
                    required: false,
                    component: 'ArrayEditor',
                    fullPath:
                      'companyConfigOverride.ui.caseTypeOrdering[0].caseTypes',
                    nested: [
                      {
                        key: '0',
                        type: 'string',
                        required: true,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.ui.caseTypeOrdering[0].caseTypes[0]',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            key: 'agentDashboardTools',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.agentDashboardTools',
            nested: [
              {
                key: 'enabled',
                type: 'boolean',
                required: false,
                component: 'Checkbox',
                fullPath:
                  'companyConfigOverride.ui.agentDashboardTools.enabled',
              },
              {
                key: 'dashboardToolDetails',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath:
                  'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails',
                nested: [
                  {
                    key: '0',
                    type: 'object',
                    required: true,
                    component: 'TextInput',
                    fullPath:
                      'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails[0]',
                    nested: [
                      {
                        key: 'name',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails[0].name',
                      },
                      {
                        key: 'url',
                        type: 'string',
                        required: false,
                        component: 'TextInput',
                        fullPath:
                          'companyConfigOverride.ui.agentDashboardTools.dashboardToolDetails[0].url',
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            key: 'websiteTitle',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.websiteTitle',
          },
          {
            key: 'favicon',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.favicon',
          },
          {
            key: 'projectSlug',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.projectSlug',
          },
          {
            key: 'phoneDisclosureNote',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.phoneDisclosureNote',
            options: ['', 'shown'],
          },
          {
            key: 'analyticsScript',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.analyticsScript',
          },
          {
            key: 'headScripts',
            type: 'string',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.headScripts',
          },
          {
            key: 'eSignDisclosure',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.eSignDisclosure',
            options: ['', 'hidden'],
          },
          {
            key: 'termsOfUse',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.termsOfUse',
            options: ['', 'hidden'],
          },
          {
            key: 'privacyPolicy',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'companyConfigOverride.ui.privacyPolicy',
            options: ['', 'hidden'],
          },
          {
            key: 'dashboard',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.ui.dashboard',
            nested: [
              {
                key: 'cases',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.dashboard.cases',
                options: ['', 'hidden'],
              },
              {
                key: 'interactions',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'companyConfigOverride.ui.dashboard.interactions',
                options: ['', 'hidden'],
              },
            ],
          },
        ],
      },
      {
        key: 'timezone',
        type: 'string',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.timezone',
      },
      {
        key: 'collections',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'companyConfigOverride.collections',
        nested: [
          {
            key: 'autoInitiate',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'companyConfigOverride.collections.autoInitiate',
            nested: [
              {
                key: 'enableReviewTask',
                type: 'boolean',
                required: false,
                component: 'Checkbox',
                fullPath:
                  'companyConfigOverride.collections.autoInitiate.enableReviewTask',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'dueDates',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'dueDates',
    nested: [
      {
        key: 'gapBetweenDueDates',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'dueDates.gapBetweenDueDates',
        nested: [
          {
            key: 'weekly',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'dueDates.gapBetweenDueDates.weekly',
            nested: [
              {
                key: 'min',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.weekly.min',
                numberFormat: 'integer',
              },
              {
                key: 'max',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.weekly.max',
                numberFormat: 'integer',
              },
            ],
          },
          {
            key: 'everyTwoWeeks',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'dueDates.gapBetweenDueDates.everyTwoWeeks',
            nested: [
              {
                key: 'min',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.everyTwoWeeks.min',
                numberFormat: 'integer',
              },
              {
                key: 'max',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.everyTwoWeeks.max',
                numberFormat: 'integer',
              },
            ],
          },
          {
            key: 'twiceMonthly',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'dueDates.gapBetweenDueDates.twiceMonthly',
            nested: [
              {
                key: 'min',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.twiceMonthly.min',
                numberFormat: 'integer',
              },
              {
                key: 'max',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.twiceMonthly.max',
                numberFormat: 'integer',
              },
            ],
          },
          {
            key: 'monthly',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'dueDates.gapBetweenDueDates.monthly',
            nested: [
              {
                key: 'min',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.monthly.min',
                numberFormat: 'integer',
              },
              {
                key: 'max',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.monthly.max',
                numberFormat: 'integer',
              },
            ],
          },
          {
            key: 'singleTerm',
            type: 'object',
            required: false,
            component: 'TextInput',
            fullPath: 'dueDates.gapBetweenDueDates.singleTerm',
            nested: [
              {
                key: 'min',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.singleTerm.min',
                numberFormat: 'integer',
              },
              {
                key: 'max',
                type: 'number',
                required: false,
                component: 'NumberInput',
                fullPath: 'dueDates.gapBetweenDueDates.singleTerm.max',
                numberFormat: 'integer',
              },
            ],
          },
        ],
      },
      {
        key: 'dayType',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dueDates.dayType',
        options: ['calendar', 'business'],
      },
      {
        key: 'dateAdjustment',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dueDates.dateAdjustment',
        options: ['forward', 'backward'],
      },
      {
        key: 'countryHolidaySchedule',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dueDates.countryHolidaySchedule',
        options: ['US', 'CA'],
      },
      {
        key: 'allowedFrequencyNewLoan',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'dueDates.allowedFrequencyNewLoan',
        nested: [
          {
            key: 'isDueDatesAvailableWeekly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyNewLoan.isDueDatesAvailableWeekly',
          },
          {
            key: 'isDueDatesAvailableEveryTwoWeeks',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyNewLoan.isDueDatesAvailableEveryTwoWeeks',
          },
          {
            key: 'isDueDatesAvailableMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyNewLoan.isDueDatesAvailableMonthly',
          },
          {
            key: 'isDueDatesAvailableTwiceMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyNewLoan.isDueDatesAvailableTwiceMonthly',
          },
          {
            key: 'isDueDatesAvailableSingleTerm',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyNewLoan.isDueDatesAvailableSingleTerm',
          },
        ],
      },
      {
        key: 'allowedFrequencyChanges',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'dueDates.allowedFrequencyChanges',
        nested: [
          {
            key: 'weeklyToWeeklyDay',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.weeklyToWeeklyDay',
          },
          {
            key: 'weeklyToEveryTwoWeeks',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.weeklyToEveryTwoWeeks',
          },
          {
            key: 'weeklyToTwiceMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.weeklyToTwiceMonthly',
          },
          {
            key: 'weeklyToMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.weeklyToMonthly',
          },
          {
            key: 'everyTwoWeeksToEveryTwoWeeksDay',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyChanges.everyTwoWeeksToEveryTwoWeeksDay',
          },
          {
            key: 'everyTwoWeeksToWeekly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.everyTwoWeeksToWeekly',
          },
          {
            key: 'everyTwoWeeksToTwiceMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyChanges.everyTwoWeeksToTwiceMonthly',
          },
          {
            key: 'everyTwoWeeksToMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.everyTwoWeeksToMonthly',
          },
          {
            key: 'twiceMonthlyToTwiceMonthlyDay',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyChanges.twiceMonthlyToTwiceMonthlyDay',
          },
          {
            key: 'twiceMonthlyToWeekly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.twiceMonthlyToWeekly',
          },
          {
            key: 'twiceMonthlyToEveryTwoWeeks',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath:
              'dueDates.allowedFrequencyChanges.twiceMonthlyToEveryTwoWeeks',
          },
          {
            key: 'twiceMonthlyToMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.twiceMonthlyToMonthly',
          },
          {
            key: 'monthlyToMonthlyDay',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.monthlyToMonthlyDay',
          },
          {
            key: 'monthlyToWeekly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.monthlyToWeekly',
          },
          {
            key: 'monthlyToEveryTwoWeeks',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.monthlyToEveryTwoWeeks',
          },
          {
            key: 'monthlyToTwiceMonthly',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'dueDates.allowedFrequencyChanges.monthlyToTwiceMonthly',
          },
        ],
      },
      {
        key: 'isShowRevisedTermsOnFrequencyChange',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'dueDates.isShowRevisedTermsOnFrequencyChange',
      },
      {
        key: 'frequencyChangesLimits',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'dueDates.frequencyChangesLimits',
        nested: [
          {
            key: 'buffer',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'dueDates.frequencyChangesLimits.buffer',
            numberFormat: 'integer',
          },
          {
            key: 'maxNumberOfAllowedChanges',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath:
              'dueDates.frequencyChangesLimits.maxNumberOfAllowedChanges',
            numberFormat: 'integer',
          },
        ],
      },
      {
        key: 'periodCalculationType',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'dueDates.periodCalculationType',
        options: ['dueDate', 'statementDate', 'fixedStatementAndDueDates'],
      },
    ],
  },
  {
    key: 'interest',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'interest',
    nested: [
      {
        key: 'dailyInterestCalculation',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'interest.dailyInterestCalculation',
        numberFormat: 'integer',
      },
      {
        key: 'periodAccrualDurationType',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'interest.periodAccrualDurationType',
        options: ['fixed', 'actual'],
      },
      {
        key: 'aprMethod',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'interest.aprMethod',
        options: ['usRule', 'actuarial'],
      },
      {
        key: 'isInterestAmountCap',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'interest.isInterestAmountCap',
      },
      {
        key: 'annualInterestRateRange',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'interest.annualInterestRateRange',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'interest.annualInterestRateRange[0]',
            nested: [
              {
                key: 'minRate',
                type: 'number',
                required: true,
                component: 'NumberInput',
                fullPath: 'interest.annualInterestRateRange[0].minRate',
                numberFormat: 'float',
              },
              {
                key: 'maxRate',
                type: 'number',
                required: true,
                component: 'NumberInput',
                fullPath: 'interest.annualInterestRateRange[0].maxRate',
                numberFormat: 'float',
              },
              {
                key: 'state',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'interest.annualInterestRateRange[0].state',
              },
              {
                key: 'country',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'interest.annualInterestRateRange[0].country',
              },
            ],
          },
        ],
      },
      {
        key: 'aprRange',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'interest.aprRange',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'interest.aprRange[0]',
            nested: [
              {
                key: 'minRate',
                type: 'number',
                required: true,
                component: 'NumberInput',
                fullPath: 'interest.aprRange[0].minRate',
                numberFormat: 'float',
              },
              {
                key: 'maxRate',
                type: 'number',
                required: true,
                component: 'NumberInput',
                fullPath: 'interest.aprRange[0].maxRate',
                numberFormat: 'float',
              },
              {
                key: 'state',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'interest.aprRange[0].state',
              },
              {
                key: 'country',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'interest.aprRange[0].country',
              },
            ],
          },
        ],
      },
      {
        key: 'indexRateAppliedTiming',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'interest.indexRateAppliedTiming',
        options: ['onIndexRateStartDate', 'onNextPeriodStartDate'],
      },
      {
        key: 'accrualMethod',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'interest.accrualMethod',
        options: ['simple', 'compound', 'compoundWithFees'],
      },
      {
        key: 'capitalization',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'interest.capitalization',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'interest.capitalization[0]',
            nested: [
              {
                key: 'capitalizationLogic',
                type: 'enum',
                required: true,
                component: 'Select',
                fullPath: 'interest.capitalization[0].capitalizationLogic',
                options: ['accruedInterestOnly', 'accruedInterestAndFees'],
              },
              {
                key: 'capLogic',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'interest.capitalization[0].capLogic',
                options: ['', 'drawCreditLimit'],
              },
              {
                key: 'state',
                type: 'string',
                required: false,
                component: 'TextInput',
                fullPath: 'interest.capitalization[0].state',
              },
              {
                key: 'country',
                type: 'string',
                required: true,
                component: 'TextInput',
                fullPath: 'interest.capitalization[0].country',
              },
            ],
          },
        ],
      },
      {
        key: 'waiveInterestWhenPrincipalZero',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'interest.waiveInterestWhenPrincipalZero',
      },
    ],
  },
  {
    key: 'creditLimit',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'creditLimit',
    nested: [
      {
        key: 'utilizationCalculation',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'creditLimit.utilizationCalculation',
        nested: [
          {
            key: '0',
            type: 'object',
            required: true,
            component: 'TextInput',
            fullPath: 'creditLimit.utilizationCalculation[0]',
            nested: [
              {
                key: 'loanStatus',
                type: 'enum',
                required: false,
                component: 'Select',
                fullPath: 'creditLimit.utilizationCalculation[0].loanStatus',
                options: ['active', 'accelerated'],
              },
              {
                key: 'balances',
                type: 'array',
                required: false,
                component: 'ArrayEditor',
                fullPath: 'creditLimit.utilizationCalculation[0].balances',
                nested: [
                  {
                    key: '0',
                    type: 'enum',
                    required: true,
                    component: 'Select',
                    fullPath:
                      'creditLimit.utilizationCalculation[0].balances[0]',
                    options: [
                      'overdueFee',
                      'overdueAccruedInterest',
                      'overduePrincipal',
                      'dueFee',
                      'dueAccruedInterest',
                      'duePrincipal',
                      'nonDueFee',
                      'nonDueAccruedInterest',
                      'nonDuePrincipal',
                      'nonAccrualFee',
                      'nonAccrualInterest',
                      'nonAccrualPrincipal',
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'duePayments',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'duePayments',
    nested: [
      {
        key: 'amortizationMethod',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'duePayments.amortizationMethod',
        options: [
          'equalPayments',
          'interestPaymentsBalloonPrincipal',
          'custom',
        ],
      },
      {
        key: 'obligationFulfilledCalculation',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'duePayments.obligationFulfilledCalculation',
        options: ['anytime', 'postStatement', 'postDueDate'],
      },
      {
        key: 'allowPrepayments',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'duePayments.allowPrepayments',
      },
      {
        key: 'customFunctionId',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'duePayments.customFunctionId',
        numberFormat: 'integer',
      },
      {
        key: 'expectedPaymentIsAmortizedDrawAllowed',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'duePayments.expectedPaymentIsAmortizedDrawAllowed',
      },
      {
        key: 'statementMinPercentageOfPrincipal',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'duePayments.statementMinPercentageOfPrincipal',
        numberFormat: 'float',
      },
      {
        key: 'statementMinAmount',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'duePayments.statementMinAmount',
        numberFormat: 'currency',
      },
    ],
  },
  {
    key: 'terms',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'terms',
    nested: [
      {
        key: 'accelerationDueWithin',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'terms.accelerationDueWithin',
        numberFormat: 'float',
      },
      {
        key: 'chargeOffDueWithin',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'terms.chargeOffDueWithin',
        numberFormat: 'integer',
      },
      {
        key: 'rightToCureBuffer',
        type: 'array',
        required: false,
        component: 'ArrayEditor',
        fullPath: 'terms.rightToCureBuffer',
        nested: [
          {
            key: '0',
            type: 'array',
            required: true,
            component: 'ArrayEditor',
            fullPath: 'terms.rightToCureBuffer[0]',
            nested: [
              {
                key: '0',
                type: 'string',
                required: true,
                component: 'TextInput',
                fullPath: 'terms.rightToCureBuffer[0][0]',
              },
            ],
          },
        ],
      },
      {
        key: 'durationReversePaymentsAfterPaidOff',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'terms.durationReversePaymentsAfterPaidOff',
        numberFormat: 'float',
      },
      {
        key: 'closeLineAfterInactivePeriods',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'terms.closeLineAfterInactivePeriods',
        numberFormat: 'integer',
      },
      {
        key: 'closeDrawAfterInactiveDays',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'terms.closeDrawAfterInactiveDays',
        numberFormat: 'integer',
      },
      {
        key: 'cancelDrawAfterInactiveDays',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'terms.cancelDrawAfterInactiveDays',
        numberFormat: 'integer',
      },
    ],
  },
  {
    key: 'statements',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'statements',
    nested: [
      {
        key: 'statementsEnabled',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.statementsEnabled',
      },
      {
        key: 'finalStatementEnabled',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.finalStatementEnabled',
      },
      {
        key: 'lateFeeUpToAmount',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'statements.lateFeeUpToAmount',
        numberFormat: 'currency',
      },
      {
        key: 'isCreateAndSendPDF',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.isCreateAndSendPDF',
      },
      {
        key: 'isDisplayMinimumPaymentWarning',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.isDisplayMinimumPaymentWarning',
      },
      {
        key: 'minPaymentWarningDurationInMonths',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'statements.minPaymentWarningDurationInMonths',
        numberFormat: 'float',
      },
      {
        key: 'isDisplayFailedPaymentsInActivity',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.isDisplayFailedPaymentsInActivity',
      },
      {
        key: 'isDisplayPostDateInActivity',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.isDisplayPostDateInActivity',
      },
      {
        key: 'statementLogicVersion',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'statements.statementLogicVersion',
        numberFormat: 'integer',
      },
      {
        key: 'statementTestLogicVersion',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'statements.statementTestLogicVersion',
        numberFormat: 'integer',
      },
      {
        key: 'bypassMinAmountDuringSCRA',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.bypassMinAmountDuringSCRA',
      },
      {
        key: 'locStatementCreationDaysOffset',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'statements.locStatementCreationDaysOffset',
        nested: [
          {
            key: 'weekly',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'statements.locStatementCreationDaysOffset.weekly',
            numberFormat: 'integer',
          },
          {
            key: 'everyTwoWeeks',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'statements.locStatementCreationDaysOffset.everyTwoWeeks',
            numberFormat: 'integer',
          },
          {
            key: 'twiceMonthly',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'statements.locStatementCreationDaysOffset.twiceMonthly',
            numberFormat: 'integer',
          },
          {
            key: 'monthly',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'statements.locStatementCreationDaysOffset.monthly',
            numberFormat: 'integer',
          },
        ],
      },
      {
        key: 'pauseStatementsAfterInactivePeriods',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'statements.pauseStatementsAfterInactivePeriods',
        numberFormat: 'integer',
      },
      {
        key: 'includeOverdueAmountInMinPayment',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.includeOverdueAmountInMinPayment',
      },
      {
        key: 'includeOverLimitAmountInMinPayment',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'statements.includeOverLimitAmountInMinPayment',
      },
      {
        key: 'overLimitAmountCalculation',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'statements.overLimitAmountCalculation',
        nested: [
          {
            key: 'bucketExclusionList',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath:
              'statements.overLimitAmountCalculation.bucketExclusionList',
            nested: [
              {
                key: '0',
                type: 'enum',
                required: true,
                component: 'Select',
                fullPath:
                  'statements.overLimitAmountCalculation.bucketExclusionList[0]',
                options: [
                  'overdueFee',
                  'overdueAccruedInterest',
                  'overduePrincipal',
                  'dueFee',
                  'dueAccruedInterest',
                  'duePrincipal',
                  'nonDueFee',
                  'nonDueAccruedInterest',
                  'nonDuePrincipal',
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    key: 'autopay',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'autopay',
    nested: [
      {
        key: 'achDebitTiming',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'autopay.achDebitTiming',
        options: ['initiateOnDueDate', 'hitOnDueDate'],
      },
      {
        key: 'achDebitTimingShiftOnNonBusinessDay',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'autopay.achDebitTimingShiftOnNonBusinessDay',
        options: ['forward', 'backward'],
      },
      {
        key: 'amountChangeNotificationBuffer',
        type: 'number',
        required: true,
        component: 'NumberInput',
        fullPath: 'autopay.amountChangeNotificationBuffer',
        numberFormat: 'currency',
      },
      {
        key: 'amountChangePercentageThreshold',
        type: 'number',
        required: true,
        component: 'NumberInput',
        fullPath: 'autopay.amountChangePercentageThreshold',
        numberFormat: 'currency',
      },
      {
        key: 'numberOfConsecutiveFailedAttempts',
        type: 'number',
        required: false,
        component: 'NumberInput',
        fullPath: 'autopay.numberOfConsecutiveFailedAttempts',
        numberFormat: 'integer',
      },
      {
        key: 'paymentsRetry',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'autopay.paymentsRetry',
        nested: [
          {
            key: 'isRetryAutopayFailedPayments',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'autopay.paymentsRetry.isRetryAutopayFailedPayments',
          },
          {
            key: 'maxNumberOfAutoRetriesPerPayment',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'autopay.paymentsRetry.maxNumberOfAutoRetriesPerPayment',
            numberFormat: 'integer',
          },
          {
            key: 'retryDayMethod',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'autopay.paymentsRetry.retryDayMethod',
            options: ['fixedBuffer', 'dayOfWeek'],
          },
          {
            key: 'retryBufferDayType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'autopay.paymentsRetry.retryBufferDayType',
            options: ['calendar', 'business'],
          },
          {
            key: 'retryBufferInDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'autopay.paymentsRetry.retryBufferInDays',
            numberFormat: 'integer',
          },
          {
            key: 'doNotRetryAfterMaxDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'autopay.paymentsRetry.doNotRetryAfterMaxDays',
            numberFormat: 'integer',
          },
          {
            key: 'retryDayOfWeek',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'autopay.paymentsRetry.retryDayOfWeek',
            numberFormat: 'integer',
          },
          {
            key: 'retryDayOfWeekMinBuffer',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'autopay.paymentsRetry.retryDayOfWeekMinBuffer',
            numberFormat: 'integer',
          },
        ],
      },
      {
        key: 'balanceCheck',
        type: 'object',
        required: false,
        component: 'TextInput',
        fullPath: 'autopay.balanceCheck',
        nested: [
          {
            key: 'enabled',
            type: 'boolean',
            required: false,
            component: 'Checkbox',
            fullPath: 'autopay.balanceCheck.enabled',
          },
          {
            key: 'checkOffsetDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'autopay.balanceCheck.checkOffsetDays',
            numberFormat: 'integer',
          },
          {
            key: 'thresholds',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'autopay.balanceCheck.thresholds',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'autopay.balanceCheck.thresholds[0]',
                nested: [
                  {
                    key: 'zone',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'autopay.balanceCheck.thresholds[0].zone',
                    options: ['balanceRed', 'balanceYellow'],
                  },
                  {
                    key: 'value',
                    type: 'number',
                    required: false,
                    component: 'NumberInput',
                    fullPath: 'autopay.balanceCheck.thresholds[0].value',
                    numberFormat: 'integer',
                  },
                ],
              },
            ],
          },
          {
            key: 'debitLogic',
            type: 'array',
            required: false,
            component: 'ArrayEditor',
            fullPath: 'autopay.balanceCheck.debitLogic',
            nested: [
              {
                key: '0',
                type: 'object',
                required: true,
                component: 'TextInput',
                fullPath: 'autopay.balanceCheck.debitLogic[0]',
                nested: [
                  {
                    key: 'condition',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'autopay.balanceCheck.debitLogic[0].condition',
                    options: [
                      'balanceRed',
                      'balanceYellow',
                      'balanceNA',
                      'balanceBroken',
                      'balanceGreen',
                    ],
                  },
                  {
                    key: 'action',
                    type: 'enum',
                    required: false,
                    component: 'Select',
                    fullPath: 'autopay.balanceCheck.debitLogic[0].action',
                    options: ['cancel', 'debit', 'reschedule'],
                  },
                ],
              },
            ],
          },
          {
            key: 'rescheduleBufferInDays',
            type: 'number',
            required: false,
            component: 'NumberInput',
            fullPath: 'autopay.balanceCheck.rescheduleBufferInDays',
            numberFormat: 'integer',
          },
          {
            key: 'rescheduleBufferDayType',
            type: 'enum',
            required: false,
            component: 'Select',
            fullPath: 'autopay.balanceCheck.rescheduleBufferDayType',
            options: ['calendar', 'business'],
          },
        ],
      },
      {
        key: 'calculationLogic',
        type: 'enum',
        required: true,
        component: 'Select',
        fullPath: 'autopay.calculationLogic',
        options: ['dynamic', 'static'],
      },
    ],
  },
  {
    key: 'drawFundsUI',
    type: 'object',
    required: false,
    component: 'TextInput',
    fullPath: 'drawFundsUI',
    nested: [
      {
        key: 'purchaseCreateLogic',
        type: 'enum',
        required: false,
        component: 'Select',
        fullPath: 'drawFundsUI.purchaseCreateLogic',
        options: ['newPurchaseRandomDraw'],
      },
      {
        key: 'isAllowedWhenOverdue',
        type: 'boolean',
        required: false,
        component: 'Checkbox',
        fullPath: 'drawFundsUI.isAllowedWhenOverdue',
      },
    ],
  },
] as const

export const getFieldSchema = (path: string): StaticFieldSchema | undefined => {
  const findByPath = (
    fields: Array<StaticFieldSchema>,
    targetPath: string,
  ): StaticFieldSchema | undefined => {
    for (const field of fields) {
      if (field.fullPath === targetPath) {
        return field
      }
      if (field.nested) {
        const found = findByPath(field.nested, targetPath)
        if (found) return found
      }
    }
    return undefined
  }

  return findByPath(lineOfCreditLoanTypeSchema, path)
}

export const getAllPaths = (): Array<string> => {
  const extractPaths = (fields: Array<StaticFieldSchema>): Array<string> => {
    const paths: Array<string> = []
    for (const field of fields) {
      if (field.fullPath) {
        paths.push(field.fullPath)
      }
      if (field.nested) {
        paths.push(...extractPaths(field.nested))
      }
    }
    return paths
  }

  return extractPaths(lineOfCreditLoanTypeSchema)
}
